export default "__VITE_PUBLIC_ASSET__ab482633__"